Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getShadowNodeWrapperFromRef = getShadowNodeWrapperFromRef;
function getShadowNodeWrapperFromRef() {
    throw new Error("[Reanimated] Trying to call `getShadowNodeWrapperFromRef` on web.");
}
